import axios from 'axios';
import EnvService from '@/plugins/EnvService';

export default class WebService {
  constructor(ctx) {
    this.ctx = ctx
    axios.defaults.validateStatus = () => {
      return true
    };
    axios.defaults.timeout = 1000 * 60 * 1 // 1min;
  }

  async login(restUrl, username, password) {
    return await axios.get(EnvService.serviceURLOptima+restUrl, {
      auth: {
        username: username,
        password: password
      }
    })
  }

  async issueNewPassword(restUrl, mailEntity) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, mailEntity)
  }

  async setNewPassword(restUrl, item) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, item)
  }

  async insertUser(restUrl, item) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, item)
  }

  async getUser(restUrl, username) {
    return await axios.get(EnvService.serviceURLOptima+restUrl+"/"+username, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getUserNoAuth(restUrl, username) {
    return await axios.get(EnvService.serviceURLOptima+restUrl+"/"+username)
  }

  //basic crud services
  async getItem(restUrl, keys) {
    return await axios.get(EnvService.serviceURLOptima+restUrl+"/"+keys[0], {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getItems(restUrl) {
    return await axios.get(EnvService.serviceURLOptima+restUrl, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getChildItems(restUrl, keys) {
    return await axios.get(EnvService.serviceURLOptima+restUrl+"/masterdetail/"+keys[0], {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async deleteItem(restUrl, keys) {
    return await axios.delete(EnvService.serviceURLOptima+restUrl+"/"+keys, {
      data: keys,
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async updateItem(restUrl, item, keys) {
    return await axios.put(EnvService.serviceURLOptima+restUrl+"/"+keys[0], item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async insertItem(restUrl, item) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  // invoice
  async calcItem(restUrl, item) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async cloneItem(restUrl, item) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async setPrintStatus(restUrl, item) {
    return await axios.put(EnvService.serviceURLOptima+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async changeInvoiceToPaid(restUrl, item) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getQRSlips(restUrl, language, keys) {
    return await axios.get(EnvService.serviceURLOptima+restUrl+"/"+language+"/"+keys, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }


  async changeItem(restUrl, item, clone) {
    return await axios.post(EnvService.serviceURLOptima+restUrl+"/"+clone, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }
  
  //database operations
  async resetSchema(restUrl) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, {}, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async rebuildData(restUrl) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, {}, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  //reporting
  async reloadReports(restUrl) {
    return await axios.get(EnvService.serviceURLReporting+restUrl, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async redeployReports(restUrl) {
    return await axios.get(EnvService.serviceURLReporting+restUrl, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getReport(restUrl, reportData) {
    return await axios.post(EnvService.serviceURLReporting+restUrl+"/"+reportData.name+"/"+reportData.outputType, reportData, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getReportAsBlob(restUrl, reportData, reportFormat) {
    return await axios.post(EnvService.serviceURLReporting+restUrl+"/"+reportData.name+"/"+reportFormat, reportData, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    })    
  }

  async createLogEntry(restUrl, logEntry) {
    return await axios.post(EnvService.serviceURLOptima+restUrl, logEntry, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

}
